import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Baseboards = (props: Icon): React.ReactElement => (
  <svg
    viewBox="0 0 57 25"
    style={{ ...style(props.size, props.height), ...props.style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-774.000000, -1035.000000)"
        fill={props.color || theme.palette.grey600}
        fillRule="nonzero"
      >
        <g transform="translate(774.000000, 1035.000000)">
          <path
            d="M27.720759,4.53550845 L27.720759,17.1842307 L-3.35326599e-12,24.9251946 L-3.35326599e-12,11.9188351 L27.720759,4.53550845 Z M29.1627907,4.53550845 L56.9891811,11.9314187 L56.9891811,24.9251946 L29.1627907,17.1764426 L29.1627907,4.53550845 Z M29.1627907,-2.53878789e-13 L56.9891811,6.76172921 L56.9891811,10.6324352 L29.1627907,2.56687495 L29.1627907,-2.53878789e-13 Z M27.720759,-1.97923549e-13 L27.720759,2.58852431 L-3.33372606e-12,10.3156269 L-3.33372606e-12,6.74859681 L27.720759,-1.97923549e-13 Z"
            id="Combined-Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);
